// EFECTOS SECUNMDARIOS ESKETAMINA

export const cadss_catalog_1 = [
    "Ritmo Cardíaco Elevado",
    "Sentimientos de Ansiedad",
    "Debilidad/Mareos ligeros",
    "Sedación/Somnolencia",
    "Nauseas",
    "Visión Borrosa",
    "Aumento de la Presión Arterial",
    "Mareos",
    "Dolor de cabeza"
]

export const cadss_catalog_2 = [
    "¿Parece que las cosas se mueven en cámara lenta?",
    "¿Te parecen irreales las cosas, como si estuvieras en un sueño?",
    "¿Te sientes desconectado de tu propio cuerpo?",
    "¿Sientes que ha cambiado el sentido de tu propio cuerpo?: por ejemplo, tu cuerpo se siente inusualmente largo o inusualmente pequeño?",
    "¿Te has distraído, o has perdido el rastro de alguna manera de lo que está pasando durante esta experiencia?",
    "¿Tiene lagunas (vacíos) en su memoria? "
]

export const responses = [[
    "0 - No en absoluto",
    "1 - Leve, las cosas parecen un poco más lentas, pero no muy notable.",
    "2 -Moderado, las cosas se mueven aproximadamente el doble que normalmente.",
    "3 -Grave, las cosas se mueven tan lentamente que apenas se mueven. ",
    "4 -Extremo, las cosas se mueven tan lentamente, que tengo la percepción de que todo se detiene, como si el tiempo se detuviera. ",
],
[
    "0 - No en absoluto. ",
    "1 - Leve, las cosas se ven un poco irreales, pero soy muy consciente de donde estoy. ",
    "2 - Moderado, las cosas parecen un sueño, aunque sé que estoy despierto. ",
    "3 - Grave, las cosas se parecen mucho a un sueño, aunque sé que estoy aquí, tengo el sentimiento de que pudiera estar dormido. ",
    "4 - Extremo, siento que nada es real, como si tuviera que pellizcarme para despertar, o preguntarle a alguien si esto es un sueño.  "
],
[
    "0 - No, en absoluto ",
    "1 - Leve, Me siento un poco desconectado de mí mismo, pero básicamente estoy completamente aquí. ",
    "2 - Moderado, Me siento algo desprendido de mi propio cuerpo, pero básicamente todo unido. ",
    "3 - Grave, me siento desprendido de mi propio cuerpo, pero no muy alejado de mi cuerpo, y siento como si estuviera yo ahí. ",
    "4 - Extremo, Me siento como si estuviera completamente fuera de mi cuerpo, como si estuviera viendo mi propio cuerpo desde muy lejos, como si estuviera otra persona ahí. "
],
[
    "0 - No, en absoluto ",
    "1 - Leve, Tengo un vago sentimiento de que algo en mi cuerpo ha cambiado, pero no puedo decir exactamente que es. ",
    "2 - Moderado, Siento como que mi cuerpo ha aumentado o disminuido ligeramente de tamaño, o se siente como si no fuera mi cuerpo. ",
    "3 - Grave, Siento como si mi cuerpo ha aumentado el doble de si tamaño normal, o disminuido el doble de su tamaño normal. ",
    "4 - Extremo, siento como si mi cuerpo se hubiera hinchado al menos diez veces de su tamaño normal o como si fuera diez veces más pequeño, o como si mis brazos se hubieran convertido como palillos de dientes. "
],
[
    "0 - No en absoluto ",
    "1 - Leve, He tenido algunos episodios de haber perdido la noción sobre lo que está pasando, pero he seguido toda la mayor parte del tiempo. ",
    "2 - Moderado, He perdido al menos un minuto de tiempo, o perdido completamente la noción de lo que está pasando ahora. ",
    "3 - Grave, He perdido varios segmentos de tiempo de un minuto o más. ",
    "4 - Extremo, he perdido largos segmentos de tiempo de al menos 15 minutos o más. "
],
[
    "0 - No en lo absoluto ",
    "1 - Leve, Hay algunas cosas recientes que no puedo recordar. ",
    "2 - Moderado, ha habido algunas lagunas(vacíos) en mi memoria que duraron unos minutos ",
    "3 - Grave, ha habido largas lagunas(vacíos) en mi memoria que duraron más de algunos minutos. ",
    "4 - Extremo, No puedo reconstruir lo que está pasando de un momento al siguiente, debido a largas lagunas(vacíos) en mi memoria. ",
]]

